import * as ActionTypes from '../ActionTypes';

const initialState = {
    atdCodeLoading: false,
    attendanceCodeData: [],
    error: null,

};
export const AttendanceReducer = (state = initialState, action) => {
    switch (action.type) {
        case ActionTypes.GET_ATTENDANCE_CODE_REQUEST:
            return {
            ...state,
            atdCodeLoading: true,
            attendanceCodeData: [],
            error: null,
        };
        case ActionTypes.UPDATE_ATTENDANCE_CODE_REQUEST:
        case ActionTypes.DELETE_ATTENDANCE_CODE_REQUEST:
        return {
            ...state,
            atdCodeLoading: true,
            error: null,
        };

        case ActionTypes.GET_ATTENDANCE_CODE_SUCCESS:
        case ActionTypes.UPDATE_ATTENDANCE_CODE_SUCCESS:
        case ActionTypes.DELETE_ATTENDANCE_CODE_SUCCESS:
        return {
            ...state,
            atdCodeLoading: false,
            attendanceCodeData: action.payload?.data?.data || [],
            error: null,
        };

        case ActionTypes.GET_ATTENDANCE_CODE_ERROR:
        case ActionTypes.UPDATE_ATTENDANCE_CODE_ERROR:
        case ActionTypes.DELETE_ATTENDANCE_CODE_ERROR:
        return {
            ...state,
            atdCodeLoading: false,
            error: true,
        };
        default:
            return state;
    }
};
